var React = require('react');

function CondenseSquare (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M21 9L15 9L15 3","stroke":"#130A09","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M4 14L10 14L10 20","stroke":"#130A09","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

CondenseSquare.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = CondenseSquare;

CondenseSquare.default = CondenseSquare;
